import type { FC } from 'react';
import type { ActionIndexProps } from '../../types';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import actionFieldsVisibility from '../../utils/actionFieldsVisibility';
import { Box } from '@mui/material';
import ActionValue from './ActionValue';

export const ActionReplaceNameFields: FC<ActionIndexProps> = ({ indexAction, indexVariant, indexTask }) => {
  const tasksFormStore = useCurrentTasksFormStore();
  const storedActionValue = tasksFormStore.getActionValues({ indexTask, indexAction, indexVariant })?.action;
  const { isReplaceInName } = actionFieldsVisibility(storedActionValue as string);
  return (
    isReplaceInName && (
      <>
        <Box
          sx={{
            flex: 1,
            borderLeft: `1px solid ${`rgba(0, 8, 46, 0.12)`}`,
            borderRight: `1px solid ${`rgba(0, 8, 46, 0.12)`}`,
          }}
        >
          <ActionValue
            indexAction={indexAction}
            indexVariant={indexVariant}
            indexTask={indexTask}
            field="value"
            type="text"
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <ActionValue
            indexAction={indexAction}
            indexTask={indexTask}
            indexVariant={indexVariant}
            field="second_value"
            type="text"
          />
        </Box>
      </>
    )
  );
};

export default ActionReplaceNameFields;
